export const ORDERED = "ORDERED";
export const FILTERED = "FILTERED";
export const FILTERED_BY_DATE = "FILTERED_BY_DATE"
export const NONE = "NONE";